<template>
  <Block class="activity-time" title="参赛要求">
    <div class="content">
      <div class="require-item" v-for="(item, i) in rules" :key="item.title">
        <div v-if="isLargeScreen === true" class="order">{{ "0" + (i + 1) }}</div>
        <div class="box">
          <div class="require-item__title">{{ isLargeScreen === true ?  item.titlePC : item.title }}</div>
          <div class="require-item__description" v-html="item.description"></div>
        </div>
      </div>
    </div>
    <Button type="to-rule" @click="handleClick"></Button>
  </Block>
</template>

<script setup lang="ts">
import Block from "./common/block.vue";
import Button from "./common/button.vue";
import useDevice from "./common/useDevice";

defineProps<{
  title?: string;
  tip?: string;
  rules?: {
    title: string;
    description: string;
  }[];
}>();

const emit = defineEmits(["toRule"]);
// const { isLargeScreen } = useDevice();

const isLargeScreen = ref(false);
const resize = () => {
  isLargeScreen.value = window.innerWidth >= 1360;
}
onMounted(() => {
  resize();
});
window.addEventListener('resize', resize);
window.addEventListener('orientationchange', resize);

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
  window.removeEventListener("orientationchange", resize);
})

const handleClick = () => {
  emit("toRule");
};
</script>

<style scoped lang="less">
.activity-time {
  width: 22.36rem;
  margin-bottom: 2.8rem;

  @media screen and(max-width: 1360px) {
    width: 100%;
    margin-top: 0;
    margin-bottom: 0.56rem;
  }
}

.content {
  margin-top: 0.8rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 0.5rem;
  // background-color: #fff;
  @media screen and(max-width: 1360px) {
    margin-bottom: 0.3rem;
  }

  .require-item {
    display: flex;
    min-height: 4.8rem;
    padding: 1.2rem 0.8rem;
    margin-bottom: 0.3rem;
    background-color: rgba(255, 255, 255, 0.04);
    border-radius: 0.16rem;

    &:first-of-type {
      background: linear-gradient(100.78deg,
          rgba(120, 133, 255, 0.12) 0%,
          rgba(255, 255, 255, 0.04) 45.37%);
    }

    &:last-of-type {
      background: linear-gradient(320.01deg,
          rgba(0, 179, 255, 0.12) 0%,
          rgba(255, 255, 255, 0.04) 45.59%);
    }

    @media screen and(max-width:1360px) {
      width: 100%;
      padding: 0;
      background: none;
      min-height: 0;
      margin-top: 0.48rem;

      &:first-of-type {
        background: none;
      }

      &:last-of-type {
        background: none;
      }
    }

    &:first-child {
      margin-top: 0;
    }

    &__title {
      color: rgba(255, 255, 255, 1);
      font-size: 0.6rem;
      font-weight: 600;
      line-height: 0.8rem;

      @media screen and(max-width: 1360px) {
        font-size: 0.28rem;
        font-weight: 500;
        line-height: 0.4rem;
      }
    }

    &__description {
      color: rgba(255, 255, 255, 0.5);
      font-size: 0.4rem;
      font-weight: 300;
      line-height: 0.56rem;
      margin-top: 0.48rem;

      @media screen and(max-width: 1360px) {
        font-size: 0.24rem;
        line-height: 0.4rem;
        margin-top: 0.12rem;
      }
    }
  }

  .order {
    font-weight: 300;
    font-size: 1.52rem;
    color: rgba(255, 255, 255, 0.2);
    line-height: 1.28rem;
  }
  .box {
    display: flex;
    flex-direction: column;
    margin-left: 0.6rem;
    // background-color: #fff;

    @media screen and (max-width: 1360px) {
      margin-left: 0;
    }
  }

  .front {
    display: inline-flex;
    width: 0.44rem;

    @media screen and (max-width: 1360px) {
      width: 0.2rem;
    }
  }

  .icon {
    display: inline-flex;
    width: 0.64rem;
    height: 0.64rem;
    background-image: url(https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/35998c57-08d3-4be7-8356-a925ea2eb1a1.png);
    background-size: 100% 100%;
    margin-left: 0.16rem;

    @media screen and (max-width: 1360px) {
      width: 0.4rem;
      height: 0.4rem;
      margin-left: 0;
    }
  }

  @media screen and(max-width: 1360px) {
    margin-top: 0.28rem;
  }

  @media screen and(max-width: 1360px) {
    max-width: 18.32rem;
  }
}

.tip {
  margin-top: 0;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.4rem;

  @media screen and(max-width: 1360px) {
    margin-top: 0.2rem;
    font-size: 0.2rem;
    color: rgba(255, 255, 255, 0.3);
  }
}

.btn {
  margin-top: 1.64rem;

  @media screen and(max-width: 1360px) {
    &.large {
      margin-top: 0.56rem;
      height: 0.8rem;

      :deep(.van-button) {
        &__content {
          padding: 0 0.2rem;
        }
      }
    }
  }
}
</style>
